import { clsx } from 'clsx';
import { healthTone } from './constants';
import styles from './HealthChip.module.css';

interface HealthChipProps {
  score: number | null;
  previousScore?: number | null;
  size?: 'sm' | 'lg';
}

/**
 * The score the Command Center promised and never showed. A null score is
 * "Not scored", never 0 — a practice with nothing to measure is a setup
 * problem, and printing a zero would read as a failing grade.
 */
export function HealthChip({ score, previousScore = null, size = 'sm' }: HealthChipProps) {
  if (score === null) {
    return <span className={styles.unscored}>Not scored</span>;
  }

  const tone = healthTone(score);
  const delta = previousScore === null ? null : score - previousScore;

  return (
    <div className={clsx(styles.chip, size === 'lg' && styles.large, styles[tone])}>
      <span className={styles.score}>
        {score}
        <span className={styles.outOf}>/100</span>
      </span>
      <span className={styles.track}>
        <span className={styles.fill} style={{ width: `${score}%` }} />
      </span>
      {delta !== null && delta !== 0 && (
        <span className={clsx(styles.delta, delta > 0 ? styles.up : styles.down)}>
          {delta > 0 ? '+' : ''}
          {delta}
        </span>
      )}
    </div>
  );
}
